import moment from 'moment-timezone'
import { toMoment } from './toMoment'

export function getMomentDiffInSeconds(value: moment.Moment): number {
  const atStartOfDay = toMoment(new Date()).moment.hour(0).minute(0).second(0).millisecond(0)
  return value.diff(atStartOfDay, 'seconds')
}
